import {RouterView} from '../RouterView.js';
import Admin from '../../components/views/registers/Index';
import Unify from "../../components/views/registers/partials/Unify";

const ManageTemplates = _ => import(/* webpackChunkName: "js/split/ManageTemplates", webpackPreload: true */ '@/components/views/registers/partials/ManageTemplates');

/*import ManageTemplates from "../../components/views/registers/partials/ManageTemplates";*/

export default{
    path: "inbox",
    component: RouterView,
    children:[
        {
            path: '',
            component:Admin
        },
        {
            path: 'unify',
            component: Unify
        },
        {
            path: 'edit-templates',
            component: ManageTemplates
        },



    ]
}
